// extracted by mini-css-extract-plugin
export var blockedMessage = "_am-3";
export var blockedOverlay = "_am-1";
export var fadeIn = "_am-2";
export var hereLink = "_am-0";
export var slideUp = "_am-4";